import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";


export class ConnectPartnerSocket {
	constructor(private repository: PartnerSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.connectPartnerSocket();
	}
	getSocket() {
        return this.repository.getSocket();
    }
}
